import type { NoteDetail } from "@/core/types";

import { NoteStatusRow } from "./components/NoteStatusRow";
import { RejectedNoteStatus } from "./components/RejectedNoteStatus";
import { ResubmittedNoteStatus } from "./components/ResubmittedNoteStatus";

type NoteStatusRouterProps = {
  note: NoteDetail;
};

export function NoteStatusRouter({ note }: NoteStatusRouterProps) {
  switch (note.note_state) {
    case "rejected":
      return <RejectedNoteStatus note={note} />;

    case "resubmitted":
      return <ResubmittedNoteStatus note={note} />;

    default:
      return <NoteStatusRow note={note} />;
  }
}
